// src/components/common/FeedbackDialog.jsx
import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Typography,
    Stack,
    Button,
    Zoom,
    Box,
    alpha,
    Avatar,
    Divider
} from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { useNotificationStore } from '../../store/useNotificationStore';

// ✅ Import du logo de l'entreprise
import logoAgence from '../../assets/logo-agence-vg.png';

const TYPE_CONFIG = {
    success: {
        color: '#6dd9a8',
        icon: <CheckCircleIcon sx={{ fontSize: 28 }} />, // Taille adaptée pour le titre
        title: 'Opération réussie'
    },
    error: {
        color: '#ef4444',
        icon: <ErrorIcon sx={{ fontSize: 28 }} />,
        title: 'Une erreur est survenue'
    },
    info: {
        color: '#4f8ef7',
        icon: <InfoOutlined sx={{ fontSize: 28 }} />,
        title: 'Information'
    }
};

export function FeedbackDialog() {
    const { isOpen, type, title, message, hide, onConfirm } = useNotificationStore();

    const config = TYPE_CONFIG[type] || TYPE_CONFIG.success;

    const handleClose = () => {
        hide();
        if (onConfirm) onConfirm();
    };

    return (
        <Dialog
            open={isOpen}
            TransitionComponent={Zoom}
            onClose={handleClose}
            PaperProps={{
                sx: {
                    borderRadius: '24px',
                    p: 1,
                    maxWidth: 420,
                    bgcolor: '#fcfcfb'
                }
            }}
        >
            {/* En-tête avec Logo et Titre dynamique */}
            <DialogTitle>
                <Box sx={{ display: "flex", flexDirection: "row", gap: 2, alignItems: "center" }}>
                    {/* Conteneur du Logo avec une petite bordure colorée selon le type */}
                    <Box
                        sx={{
                            width: 50,
                            height: 50,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '12px',
                            bgcolor: 'white',
                            border: `2px solid ${alpha(config.color, 0.3)}`,
                            p: 0.5,
                            boxShadow: `0 4px 12px ${alpha(config.color, 0.1)}`
                        }}
                    >
                        <img
                            src={logoAgence}
                            alt="Logo Agence"
                            style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
                        />
                    </Box>

                    <Typography
                        sx={{
                            fontWeight: 700,
                            fontSize: '1.4rem',
                            color: '#1a1a2e',
                            fontFamily: "'Cormorant Garamond', serif",
                            lineHeight: 1.2
                        }}
                    >
                        {config.title}
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1, alignItems: "center" }}>
                    <Box>
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1 }}>
                            <Avatar sx={{ width: 70, height: 70, bgcolor: alpha(config.color, 0.1), color: config.color }}>
                                {config.icon}
                            </Avatar>
                            <Typography sx={{ fontWeight: 700, fontSize: '1.5rem', color: '#1a1a2e', fontFamily: "'Cormorant Garamond', serif" }}>
                                {title}
                            </Typography>
                        </Box>
                        <Typography sx={{ color: 'rgba(26,26,46,0.6)', mt: 1 }}>{message}</Typography>
                    </Box>
                    <Button fullWidth variant="contained" onClick={handleClose}
                        sx={{ bgcolor: '#1a1a2e', borderRadius: '12px', py: 1.5, fontWeight: 700, textTransform: 'none' }}>
                        Continuer
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
}